module.exports = __webpack_public_path__ + "img/dlt_kind_10.39f3802c.png";